import {
  Avatar,
  Box,
  Button,
  Chip,
  Divider,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Paper,
  Slide,
  Stack,
  Switch,
  Tab,
  Tabs,
  Tooltip,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import {
  useDispatch,
  useSelector,
} from 'react-redux';

// actions
import {
  AccessAlarm,
  AccountBox,
  AttachFile,
  Bookmark,
  CalendarMonth,
  CheckBox,
  CheckBoxOutlineBlank,
  Delete,
  EventRepeat,
  Group,
  History,
  Info,
  LocalOffer,
  LocationOn,
  PendingActions,
  Reorder,
} from '@mui/icons-material';
import moment from 'moment';

import { getIcon } from '../../../pages/horse/Horse/components/LocationsCard';
import {
  setGlobalModals,
  setSelectedTaskForSchedule,
} from '../../../redux/app/actions';
import { updateBarn } from '../../../redux/barn/actions';
import { SCHEDULE_MODAL_TYPE } from '../../../redux/app/types';
import { getIconForItem } from '../../../utils/iconHelper';
import { getScheduleSeriesText } from '../../../utils/scheduleHelper';
import { getLocationForTags } from '../../../utils/tagsHelper';
import EventUpload from '../../EventUpload';
import Horse, { getHorsePictureUrl } from '../../Horse';
import HorseTaskReminderIndicator from '../../HorseTaskReminders/Indicator';
import LocationChip from '../../LocationChip';
import Property from '../../Property';
import { getBarnHorse } from '../../Schedule/ScheduleTaskItem';
import TagList from '../../TagList';
import TaskStatus, { getColorForItem } from '../../TaskStatus';
import User from '../../User';
import AddCommentCard from '../AddCommentCard';
import {
  EditTaskEventDataComponent,
  isNumber,
} from '../EditTaskEventData';
import EventHistoryCard from '../EventHistoryCard';

export const transition = React.forwardRef((props, ref) => <Slide direction="up" {...props} ref={ref} />);

const getIconForTask = (task, selectedBarn) => {
  if (task.archived) {
    return (
      <Delete
        sx={{
          width: '16px',
          height: '16px',
        }}
        viewBox="3 3 18 18"
      />
    )
  }
  if (task.currentEventStatus && task.currentEventStatus.status.id !== selectedBarn.barnMetadata.statusPendingId
    && task.currentEventStatus.status.id !== selectedBarn.barnMetadata.statusStartId
    && task.currentEventStatus.status.id !== selectedBarn.barnMetadata.statusEndId) {
    return (
      <Bookmark
        sx={{
          width: '16px',
          height: '16px',
        }}
        viewBox="3 3 18 18"
        color="primary"
      />
    )
  }
  if (!task.archived && task.completeDate) {
    return (
      <CheckBox
        sx={{
          width: '16px',
          height: '16px',
        }}
        viewBox="3 3 18 18"
        color="primary"
      />
    )
  }
  if (!task.archived && !task.completeDate) {
    return (
      <CheckBoxOutlineBlank
        sx={{
          width: '16px',
          height: '16px',
        }}
        viewBox="3 3 18 18"
        color="primary"
      />
    )
  }
  return (
    <Bookmark
      sx={{
        width: '16px',
        height: '16px',
      }}
      viewBox="3 3 18 18"
      color="primary"
    />
  )
}

const orderNumbers = Array.from({ length: 20 }, (_, i) => i + 1);

const TaskHighlightComponent = ({
  task,
  currentStatusAssignment,
  detailedLocation,
  scheduleAssignment,
  canAttachFiles,
  handleClose,
  handleEventStatus,
  isUpdatingEvent,
  selectedEventBarnHorse,
  selectedEventLocation,
  onEdit,
  associatedTasks,
  handleEventDataChange,
  schedule,
  isAllDayScheduledTask,
}) => {
  const dispatch = useDispatch();

  const [tab, setTab] = React.useState(0);
  const [actionType, setActionType] = React.useState('Comment')
  const [orderMenunchorEl, setOrderMenuAnchorEl] = React.useState(null);
  const [openTimingDialog, setOpenTimingDialog] = React.useState(false);
  const [createNoteAtTaskCreation, setCreateNoteAtTaskCreation] = React.useState(false);
  const [createBillableAtTaskCreation, setCreateBillableAtTaskCreation] = React.useState(false);
  const openOrderMenu = Boolean(orderMenunchorEl);

  React.useEffect(() => {
    setTab(0);
    setActionType('Comment')
  }, [task])
  const barnUsers = useSelector((state) => state.barn.barnUsers);
  const statuses = useSelector((state) => state.status.statuses);
  const barnHorsesMap = useSelector((state) => state.barn.barnHorsesMap);
  const selectedBarn = useSelector((state) => state.barn.selectedBarn);
  const locationsMap = useSelector((state) => state.location.locationsMap)
  const eventData = useSelector((state) => state.eventData.eventData);
  const permissions = useSelector((state) => state.user.permissions);
  const isUpdatingBarn = useSelector((state) => state.barn.isFetchingBarns);
  const horseBillable = useSelector((state) => state.app.billableForTask);
  const horseNote = useSelector((state) => state.app.noteForTask);
  const modalCallback = useSelector((state) => state.app.modalCallback);

  const editProps = {
    sx: {
      '&:hover': { cursor: 'pointer' },
      textWrap: 'auto',
    },
    onClick: onEdit,
  }
  const headerBackgroundColor = (task && task.eventData && task.eventData.Color && task.eventData.Color.value)
    || task.main;
  const displayOrder = (task.eventData['Display Order'] && task.eventData['Display Order'].value)
  const scheduleSeriesText = schedule && schedule.id && getScheduleSeriesText(schedule);
  const taskDateTitle = isAllDayScheduledTask
    ? 'Task Date'
    : 'Task Date & Time';
  const taskDateValue = task.startDate
    ? moment(task.startDate).format(isAllDayScheduledTask
      ? 'll'
      : 'lll')
    : 'No start date set';
  const dueDateValue = task.dueDate
    ? moment(task.dueDate).format('lll')
    : 'No due date set';
  const completionDateValue = task.completeDate
    ? moment(task.completeDate).format('lll')
    : null;
  const filteredTaskTags = task.tags.filter((t) => t.id !== ((selectedEventBarnHorse && parseInt(selectedEventBarnHorse.pingumTagId, 10))
    || (selectedEventLocation && parseInt(selectedEventLocation.pingumTagId, 10)) || -1));
  const scheduledLocation = (schedule && schedule.location) || detailedLocation;

  const handleOpenRepeatingTask = () => {
    if (isUpdatingEvent) return;
    const tags = ((schedule && schedule.tags) || (task && task.tags) || []);
    const locationTag = tags.find((tag) => tag.tagType.id === selectedBarn.barnMetadata.locationTagTypeId);
    const eventTypeTag = tags.find((tag) => tag.id === selectedBarn.barnMetadata.eventTaskTypeTagId);
    const locationId = (eventTypeTag && (locationTag && locationTag.id)) || null;

    dispatch(setGlobalModals(
      SCHEDULE_MODAL_TYPE,
      task,
      schedule,
      null,
      {
        locationId,
        taskTagIds: [],
        eventTemplateTagTypeFilter: -1,
        openInSeries: true,
        startDate: null,
      },
      modalCallback,
    ));
  };

  const getEDNameFromId = (id) => (eventData.find((ed) => ed.id === id) || { name: 'Unknown' }).name
  const billableFieldName = getEDNameFromId(selectedBarn.barnMetadata.horseBillablePriceEventDataId);
  const noteTypeFieldName = getEDNameFromId(selectedBarn.barnMetadata.horseNoteTypeEventDataId);
  const pendingBillableValue = task.eventData
    && task.eventData[billableFieldName]
    && task.eventData[billableFieldName].value;
  const pendingNoteTypeValue = task.eventData
    && task.eventData[noteTypeFieldName]
    && task.eventData[noteTypeFieldName].value;
  const hasPendingBillable = !task.completeDate
    && pendingBillableValue !== null
    && pendingBillableValue !== undefined
    && `${pendingBillableValue}`.trim().length > 0;
  const hasPendingNote = !task.completeDate
    && pendingNoteTypeValue !== null
    && pendingNoteTypeValue !== undefined
    && `${pendingNoteTypeValue}`.trim().length > 0;
  const hasAssociatedBillable = !!((horseBillable && horseBillable.id) || hasPendingBillable);
  const hasAssociatedNote = !!((horseNote && horseNote.id) || hasPendingNote);
  const canManageOutputTiming = !!(permissions && (permissions.owner || permissions.admin));

  React.useEffect(() => {
    if (openTimingDialog && selectedBarn && selectedBarn.barnMetadata) {
      setCreateNoteAtTaskCreation(selectedBarn.barnMetadata.createNoteAtTaskCreation === true);
      setCreateBillableAtTaskCreation(selectedBarn.barnMetadata.createBillableAtTaskCreation === true);
    }
  }, [openTimingDialog, selectedBarn]);

  const handleSaveTiming = () => {
    if (!selectedBarn || isUpdatingBarn) return;

    dispatch(updateBarn(selectedBarn.id, {
      createNoteAtTaskCreation,
      createBillableAtTaskCreation,
    })).then(() => {
      setOpenTimingDialog(false);
    });
  };

  const handleDataChange = (edId, type, value) => {
    const newEventData = {
      ...task.eventData,
      [isNumber(edId)
        ? getEDNameFromId(edId)
        : edId]: {
        type,
        value,
      },
    }
    if (edId === 'Billable Receivable') {
      newEventData['Billable Status'] = {
        type: 'Text',
        value: value === 'no'
          ? 'Expense'
          : 'Open',
      }
    }
    handleEventDataChange(newEventData, true);
  }

  const listItemSx = {
    px: 1,
    py: 0.75,
  };

  const listItemIconSx = {
    minWidth: 32,
    mr: 0.5,
    '& .MuiSvgIcon-root': {
      fontSize: 22,
      width: '1.25rem',
      height: '1.25rem',
    },
  };
  const renderEmptyState = (text) => (
    <Box
      sx={{
        color: 'text.secondary',
        fontWeight: 300,
      }}
    >
      {text}
    </Box>
  );
  const renderDetailItem = ({
    icon,
    title,
    children,
    onClick = onEdit,
  }) => (
    <ListItem dense sx={listItemSx}>
      <ListItemIcon sx={listItemIconSx}>{icon}</ListItemIcon>
      <ListItemText
        sx={{
          '&:hover': onClick
            ? { cursor: 'pointer' }
            : undefined,
          textWrap: 'auto',
        }}
        onClick={onClick}
      >
        <Typography
          variant="subtitle2"
          sx={{
            fontWeight: 600,
            lineHeight: 1.3,
          }}
        >
          {title}
        </Typography>
        <Box sx={{ mt: 0.25 }}>
          {children}
        </Box>
      </ListItemText>
    </ListItem>
  );

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <Box
        sx={{
          flex: 1,
          overflowY: 'auto',
        }}
      >
        <Paper
          sx={{
            borderRadius: 3,
            p: 2,
            mb: 2,
          }}
        >
          <Stack spacing={2}>
            <Stack
              direction={{
                xs: 'column',
                sm: 'row',
              }}
              spacing={2}
              alignItems="center"
            >
              <Box display="flex" alignItems="center" gap={1} flexWrap="wrap" sx={{ minWidth: 0 }}>
                {!selectedEventBarnHorse && <Avatar> <LocationOn /></Avatar>}
                <ListItemText
                  primary={selectedEventBarnHorse && (<Horse horse={selectedEventBarnHorse.horse} />)}
                  secondary={selectedEventLocation && <LocationChip location={selectedEventLocation} />}
                />
                {selectedEventBarnHorse && (
                  <HorseTaskReminderIndicator
                    tagId={selectedEventBarnHorse.pingumTagId}
                    eventTemplateId={task.eventTemplateId}
                  />
                )}
              </Box>
              <Stack direction="row" spacing={1} alignItems="center" justifyContent="flex-end" sx={{ flex: 1 }} flexWrap="wrap">
                <Typography variant="body2" color="text.secondary">
                  Display Order
                </Typography>
                <Tooltip placement="left" title="Barn Board Task Display Order">
                  <IconButton onClick={(e) => setOrderMenuAnchorEl(e.currentTarget)} size="small">
                    {displayOrder || <Reorder color="secondary" />}
                  </IconButton>
                </Tooltip>
              </Stack>
            </Stack>
            <Stack
              direction={{
                xs: 'column',
                sm: 'row',
              }}
              spacing={2}
              alignItems={{
                xs: 'flex-start',
                sm: 'center',
              }}
              justifyContent="space-between"
            >
              <TaskStatus
                eventStatus={task.currentEventStatus}
                icon={getIconForItem(statuses, task.currentEventStatus && task.currentEventStatus.status.id)}
                color={getColorForItem(statuses, task.currentEventStatus && task.currentEventStatus.status.id)}
                archived={task.archived}
                complete={!!(task && task.completeDate)}
                onStatusIconPress={() => handleEventStatus({ completeEvent: !task.completeDate }, task, true)}
              />
            </Stack>
            <Tabs
              value={tab}
              onChange={(e, t) => setTab(t)}
              aria-label="Task Tabs"
              sx={{
                minHeight: 35,
                maxHeight: 35,
              }}
            >
              <Tab
                sx={{
                  py: 0,
                  minHeight: 28,
                  maxHeight: 28,
                  flex: 1,
                }}
                icon={<Info sx={{ mr: '4px !important' }} />}
                iconPosition="start"
                label="Details"
              />
              <Tab
                sx={{
                  py: 0,
                  minHeight: 28,
                  maxHeight: 28,
                  flex: 1,
                }}
                icon={<History sx={{ mr: '4px !important' }} />}
                iconPosition="start"
                label={`History (${(task.eventStatuses || []).length + (task.eventUploads || []).length + (task.comments || []).filter((comment) => comment.commentHeader.indexOf('New Status For Event') === -1).length})`}
              />
              <Tab
                sx={{
                  py: 0,
                  minHeight: 28,
                  maxHeight: 28,
                  display: 'none',
                }}
                icon={<PendingActions sx={{ mr: '4px !important' }} />}
                iconPosition="start"
                label="Actions"
              />
            </Tabs>
          </Stack>
        </Paper>
        <Menu
          id="basic-menu"
          anchorEl={orderMenunchorEl}
          open={openOrderMenu}
          onClose={() => setOrderMenuAnchorEl(null)}
          value={displayOrder || -1}
        >
          <MenuItem
            key="order-item-null"
            value={-1}
            onClick={(e) => {
              e.stopPropagation();
              handleDataChange('Display Order', 'Text', e.target.value < 0
                ? null
                : e.target.value)
              setOrderMenuAnchorEl(null)
            }}
          />
          {
            orderNumbers.map((item) => (
              <MenuItem
                key={`order-item-${item}`}
                value={item}
                onClick={(e) => {
                  handleDataChange('Display Order', 'Text', e.target.value < 0
                    ? null
                    : e.target.value)
                  setOrderMenuAnchorEl(null)
                }}
              >
                {item}
              </MenuItem>
            ))
          }
        </Menu>
        {
          tab === 0 && (
            <Stack spacing={2}>
              <Paper
                sx={{ borderRadius: 3 }}
              >
                <List disablePadding>
                  {renderDetailItem({
                    icon: <AccountBox />,
                    title: 'Assigned To',
                    children: currentStatusAssignment
                      ? (
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            gap: 1,
                          }}
                        >
                          {currentStatusAssignment.split(/(?=@\[)/)
                            .map((assignment) => {
                              const idMatch = assignment.match(/@\[.*\]\((.*)\)/);
                              const nameMatch = assignment.match(/@\[(.*)\]\(/);
                              const userId = (idMatch && idMatch[1]) || assignment;
                              const userName = (nameMatch && nameMatch[1]) || '';
                              return (
                                <User
                                  key={userId}
                                  chip
                                  user={{
                                    auth0UserId: userId,
                                    userFullName: userName,
                                  }}
                                  sx={{ margin: '0 0 0 8px !important' }}
                                />
                              );
                            })}
                        </Box>
                      )
                      : renderEmptyState('No one is currently assigned'),
                  })}
                  {renderDetailItem({
                    icon: <CalendarMonth />,
                    title: taskDateTitle,
                    children: taskDateValue,
                  })}
                  {renderDetailItem({
                    icon: task.completeDate
                      ? <CheckBox />
                      : <AccessAlarm />,
                    title: task.completeDate
                      ? 'Completion Date'
                      : 'Due Date',
                    children: task.completeDate
                      ? completionDateValue
                      : (
                        <Box
                          sx={{
                            color: (!task.completeDate && task.dueDate && new Date(task.dueDate).getTime() < new Date().getTime())
                              ? 'error.main'
                              : 'inherit',
                          }}
                        >
                          {dueDateValue}
                        </Box>
                      ),
                  })}
                  {scheduledLocation && renderDetailItem({
                    icon: <LocationOn />,
                    title: 'Scheduled Location',
                    children: scheduledLocation,
                  })}
                  {renderDetailItem({
                    icon: <Info />,
                    title: 'Description',
                    children: task.description || renderEmptyState('No description added yet'),
                  })}
                  {renderDetailItem({
                    icon: <LocalOffer />,
                    title: 'Tags',
                    children: filteredTaskTags.length > 0
                      ? (
                        <TagList
                          disableGutters
                          tags={filteredTaskTags}
                        />
                      )
                      : renderEmptyState('No extra tags added'),
                  })}
                  {scheduleSeriesText && (
                    renderDetailItem({
                      icon: <EventRepeat />,
                      title: 'Repeating Task',
                      children: `Repeats ${scheduleSeriesText}`,
                      onClick: handleOpenRepeatingTask,
                    })
                  )}
                  {renderDetailItem({
                    icon: <Group />,
                    title: 'Participants',
                    children: scheduleAssignment
                      ? (
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            gap: 1,
                          }}
                        >
                          {scheduleAssignment.split(/(?=@\[)/)
                            .map((participant) => {
                              const idMatch = participant.match(/@\[.*\]\((.*)\)/);
                              const nameMatch = participant.match(/@\[(.*)\]\(/);
                              const userId = (idMatch && idMatch[1]) || participant;
                              const userName = (nameMatch && nameMatch[1]) || '';
                              return (
                                <User
                                  key={userId}
                                  chip
                                  user={{
                                    auth0UserId: userId,
                                    userFullName: userName,
                                  }}
                                  sx={{ margin: '0 0 0 8px !important' }}
                                />
                              );
                            })}
                        </Box>
                      )
                      : renderEmptyState('No participants added'),
                  })}
                </List>
              </Paper>
              {selectedEventBarnHorse && (
                <Paper
                  sx={{
                    borderRadius: 3,
                    p: 1,
                  }}
                >
                  <Box
                    {...editProps}
                    sx={{
                      ...editProps.sx,
                      '& .MuiListItem-root': listItemSx,
                      '& .MuiListItemIcon-root': listItemIconSx,
                    }}
                  >
                    <EditTaskEventDataComponent
                      taskEventData={task.eventData}
                      onChange={null}
                      completeDate={task.completeDate}
                      selectedEvent={task}
                      barnHorse={selectedEventBarnHorse}
                      showDivider={false}
                      editAtStart={false}
                    />
                  </Box>
                  {canManageOutputTiming
                    && (hasAssociatedBillable || hasAssociatedNote)
                    && (
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'flex-end',
                          mt: 1,
                        }}
                      >
                        <Button
                          size="small"
                          variant="text"
                          sx={{
                            minWidth: 0,
                            p: 0,
                            textTransform: 'none',
                            textDecoration: 'underline',
                          }}
                          onClick={(event) => {
                            event.stopPropagation();
                            setOpenTimingDialog(true);
                          }}
                        >
                          Manage when this is created
                        </Button>
                      </Box>
                    )}
                </Paper>
              )}
              <Dialog
                open={openTimingDialog}
                onClose={isUpdatingBarn
                  ? undefined
                  : () => setOpenTimingDialog(false)}
                fullWidth
                maxWidth="sm"
              >
                <DialogTitle>Manage when this is created</DialogTitle>
                <DialogContent dividers>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    Choose when new horse notes and billing transactions are created for this barn. Existing records are not duplicated or moved.
                  </Typography>
                  <FormControlLabel
                    control={(
                      <Switch
                        checked={createNoteAtTaskCreation}
                        onChange={(event) => setCreateNoteAtTaskCreation(event.target.checked)}
                        disabled={isUpdatingBarn}
                      />
                    )}
                    label="Create horse notes when the task starts"
                  />
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{
                      ml: 6,
                      mb: 2,
                    }}
                  >
                    {createNoteAtTaskCreation
                      ? 'Create the horse note when the task starts so staff can update it while the task is in progress.'
                      : 'Keep the note on the task and create the horse note when the task is completed.'}
                  </Typography>
                  <FormControlLabel
                    control={(
                      <Switch
                        checked={createBillableAtTaskCreation}
                        onChange={(event) => setCreateBillableAtTaskCreation(event.target.checked)}
                        disabled={isUpdatingBarn}
                      />
                    )}
                    label="Create billing transactions when the task starts"
                  />
                  <Typography variant="body2" color="text.secondary" sx={{ ml: 6 }}>
                    {createBillableAtTaskCreation
                      ? 'Create the billing transaction when the task starts so staff can verify or update it while the task is in progress.'
                      : 'Keep the billing details on the task and create the transaction when the task is completed.'}
                  </Typography>
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => setOpenTimingDialog(false)} disabled={isUpdatingBarn}>
                    Cancel
                  </Button>
                  <Button onClick={handleSaveTiming} variant="contained" disabled={isUpdatingBarn}>
                    Save
                  </Button>
                </DialogActions>
              </Dialog>
              {canAttachFiles
                && task.eventUploads
                && task.eventUploads.length > 0
                && (
                  <Paper
                    sx={{
                      borderRadius: 3,
                      p: 2,
                    }}
                  >
                    <List disablePadding>
                      <ListItem dense sx={listItemSx}>
                        <ListItemIcon sx={listItemIconSx}><AttachFile /></ListItemIcon>
                        <ListItemText>
                          <Property disableGutters label="Task Attachments">
                            {task.eventUploads.map((upload) => (
                              <div key={upload.id}>
                                <EventUpload eventUpload={upload} editable />
                              </div>
                            ))}
                          </Property>
                        </ListItemText>
                      </ListItem>
                    </List>
                  </Paper>
                )}
              {associatedTasks.length > 1 && (
                <Paper
                  sx={{
                    borderRadius: 3,
                    p: 2,
                  }}
                >
                  {associatedTasks.length > 1 && (
                    <Typography
                      variant="caption"
                      sx={{
                        fontWeight: 300,
                        mb: 1,
                        display: 'block',
                      }}
                    >
                      All Related Tasks
                    </Typography>
                  )}
                  {associatedTasks.length > 1 && (
                    <List
                      sx={{
                        p: 0,
                        maxHeight: 300,
                        overflowY: 'auto',
                      }}
                    >
                      {associatedTasks.map((t, index) => {
                        const barnHorse = getBarnHorse(t, null, barnHorsesMap, selectedBarn.barnMetadata.horseTagTypeId);
                        const location = !barnHorse && getLocationForTags(t.tags, selectedBarn.barnMetadata.locationTagTypeId, locationsMap);
                        return (
                          <ListItemButton
                            key={t.id}
                            dense
                            disablePadding
                            disabled={t.archived}
                            onClick={() => { dispatch(setSelectedTaskForSchedule(t)); }}
                            sx={{
                              borderLeft: `8px solid ${headerBackgroundColor}`,
                              background: t.completeDate
                                ? 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAAXNSR0IArs4c6QAAAEFJREFUKFNjZCAAzp492wBSwohPHUyRsbFxA06FyIpwmoiuCKtCbIowFOJShKIQnyK4QkKKwAqJUQRXCAonQgEPAL3PJvK6J0w6AAAAAElFTkSuQmCC)'
                                : undefined,
                              backgroundColor: t.completeDate
                                ? 'rgb(182, 190, 196)'
                                : undefined,
                              borderTopLeftRadius: index === 0
                                ? 4
                                : 0,
                              borderBottomLeftRadius: (index === associatedTasks.length - 1)
                                ? 4
                                : 0,
                            }}
                          >
                            <ListItemAvatar>
                              <Avatar
                                alt={barnHorse
                                  ? barnHorse.horse.name
                                  : ((location && location.name) || 'none')}
                                src={barnHorse
                                  ? getHorsePictureUrl(barnHorse.horse)
                                  : null}
                              >
                                {location
                                  ? getIcon(location)
                                  : ''}
                              </Avatar>
                            </ListItemAvatar>
                            <ListItemText
                              sx={{ flex: 1 }}
                              primary={barnHorse
                                ? barnHorse.horse.name
                                : location.name}
                              secondary={barnHorse && barnHorse.horse.showName}
                            />
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                              }}
                            >
                              {task.id === t.id && <Chip size="small" label="Selected" color="primary" />}
                              {t.eventData && t.eventData['Display Order'] && t.eventData['Display Order'].value && <Chip sx={{ ml: 1 }} size="small" label={t.eventData['Display Order'].value} />}
                              <IconButton
                                edge="end"
                                aria-label="toggle-complete"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleEventStatus({ completeEvent: !t.completeDate }, t, true)
                                }}
                              >
                                {getIconForTask(t, selectedBarn)}
                              </IconButton>
                            </Box>
                          </ListItemButton>

                        )
                      })}
                    </List>
                  )}
                </Paper>
              )}
            </Stack>
          )
        }
        {
          tab === 1 && (
            <EventHistoryCard showActionCard={false} tenantUsers={barnUsers} />
          )
        }
        {
          tab === 2 && (
            <AddCommentCard onSuccessfulAction={() => { setTab(1); }} actionType={actionType} />
          )
        }
      </Box>
      <Box>
        <Divider sx={{ pb: 2 }} />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Button sx={{ mr: 1 }} onClick={handleClose} disabled={isUpdatingEvent}>Cancel</Button>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              py: 1,
              flex: 1,
            }}
          >
            {
              tab !== 2
                ? (
                  <Button sx={{ mr: 1 }} color="secondary" variant="outlined" onClick={() => { setActionType('status'); setTab(2) }}>
                    Change Status
                  </Button>
                )
                : <Box />
            }
            {
              tab !== 2 && (
                <Button
                  sx={{ flex: 1 }}
                  onClick={() => handleEventStatus({ completeEvent: !task.completeDate })}
                  disabled={isUpdatingEvent}
                  color="primary"
                  variant={task.completeDate
                    ? 'text'
                    : 'contained'}
                >
                  {
                    task.completeDate
                      ? 'Mark Uncomplete'
                      : 'Mark Complete'
                  }
                </Button>
              )
            }
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

TaskHighlightComponent.propTypes = {
  task: PropTypes.object.isRequired,
  canAttachFiles: PropTypes.bool,
  currentStatusAssignment: PropTypes.string,
  detailedLocation: PropTypes.string,
  scheduleAssignment: PropTypes.string,
  handleClose: PropTypes.func.isRequired,
  handleEventStatus: PropTypes.func.isRequired,
  isUpdatingEvent: PropTypes.bool,
  selectedEventBarnHorse: PropTypes.object,
  selectedEventLocation: PropTypes.object,
  onEdit: PropTypes.func.isRequired,
  associatedTasks: PropTypes.array,
  handleEventDataChange: PropTypes.func,
  schedule: PropTypes.object,
  isAllDayScheduledTask: PropTypes.bool,
};

TaskHighlightComponent.defaultProps = {
  canAttachFiles: false,
  currentStatusAssignment: null,
  detailedLocation: null,
  scheduleAssignment: null,
  isUpdatingEvent: false,
  selectedEventBarnHorse: null,
  selectedEventLocation: null,
  associatedTasks: [],
  handleEventDataChange: () => { },
  schedule: null,
  isAllDayScheduledTask: false,
};

export default (TaskHighlightComponent);
